<template>
  <div class="">
    <div class="row teaser" id="teaser">
      <div class="col-12 text-center about__box">
     
         <div class="about__headline" v-html="content.data.teasers.intro"></div>
         <div class="about__content mb-3" v-html="content.data.teasers.content"></div>
        <div v-for="(box, i) in boxes" :key="i">
          <div v-show="i === activeIndex" >
            <h2 class="about__headline">
              {{ box.intro }}
            </h2>
            <img
              v-if="box.content_img"
              :src="box.content_img"
              class="about__img mb-3"
              alt="Pakiet Pszczelego Bohatera"
            />
            <div class="about__content" v-html="box.content"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="teaser__container flex">
      <div class="teaser__wrapper">
        <div
          v-for="(box, i) in boxes"
          :key="i"
          class="teaser__box"
          :class="{ active: i === activeIndex }"
        >
          <img
            class="teaser__icon"
            v-show="i !== activeIndex"
            :src="box.img"
            alt="ikona"
            @click="setActive(i)"
          />
          <img
            class="teaser__icon"
            v-show="i === activeIndex"
            :src="box.img_active"
            alt="ikona"
            @click="setActive(i)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "teaser",

  inject: ["content", "appData"],
  data() {
    return {
      boxes: this.content.data.teasers.boxes,
      activeIndex: 0,
      showMenuContent: this.appData.showAdditionalNav,
    };
  },
  methods: {
    setActive(index) {
      this.activeIndex = index;
      //this.scrollToElement();
    },
    scrollToElement() {
      let positionOfElement = document.getElementById("teaser").offsetTop;
      if (window.innerWidth < 1200) {
        window.scroll({
          top: positionOfElement +200,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: positionOfElement,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>
